// extracted by mini-css-extract-plugin
export var closeButton = "_2y-3";
export var header = "_2y-0";
export var link = "_2y-1";
export var retryButton = "_2y-2";